/**
 * @generated SignedSource<<e230b6506414bbc139dd5e1f63884341>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type listPageGeneralAssetManufacturersQuery$variables = {
  first: number;
};
export type listPageGeneralAssetManufacturersQueryVariables = listPageGeneralAssetManufacturersQuery$variables;
export type listPageGeneralAssetManufacturersQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"GeneralAssetManufacturersTable_generalAssetManufacturers">;
};
export type listPageGeneralAssetManufacturersQueryResponse = listPageGeneralAssetManufacturersQuery$data;
export type listPageGeneralAssetManufacturersQuery = {
  variables: listPageGeneralAssetManufacturersQueryVariables;
  response: listPageGeneralAssetManufacturersQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "listPageGeneralAssetManufacturersQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "GeneralAssetManufacturersTable_generalAssetManufacturers"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "listPageGeneralAssetManufacturersQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GeneralAssetManufacturerConnection",
        "kind": "LinkedField",
        "name": "generalAssetManufacturers",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GeneralAssetManufacturerEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GeneralAssetManufacturer",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "filters": [
          "orderBy",
          "name"
        ],
        "handle": "connection",
        "key": "GeneralAssetManufacturersList_generalAssetManufacturers",
        "kind": "LinkedHandle",
        "name": "generalAssetManufacturers"
      }
    ]
  },
  "params": {
    "cacheID": "656653685d732a2e9095b17075d53d3d",
    "id": null,
    "metadata": {},
    "name": "listPageGeneralAssetManufacturersQuery",
    "operationKind": "query",
    "text": "query listPageGeneralAssetManufacturersQuery(\n  $first: Int!\n) {\n  ...GeneralAssetManufacturersTable_generalAssetManufacturers_3ASum4\n}\n\nfragment GeneralAssetManufacturersTable_generalAssetManufacturers_3ASum4 on Query {\n  generalAssetManufacturers(first: $first) {\n    totalCount\n    pageInfo {\n      hasPreviousPage\n      hasNextPage\n      startCursor\n      endCursor\n    }\n    edges {\n      node {\n        id\n        createdAt\n        name\n        __typename\n      }\n      cursor\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4c1275dc38114d960df10ca8a4ea0fcb";

export default node;
